module.exports = __webpack_public_path__ + "officialStatic/img/sw-detailList12.59df7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/sw-detailList12.png
// module id = eY4p
// module chunks = 0